export enum CardType {
    Yellow,
    Red
}

export class Card {
    type: CardType;
    minute: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/card.model.ts